import { useGetLmsTrainingReportInstructorsQuery, useAddLmsTrainingReportInstructorMutation, useDeleteLmsTrainingReportInstructorMutation } from '../../../../api';
import { formatErrorMessage } from '../../../../utils/errorUtils';
import useTrainingReportSubListData from './useTrainingReportSubListData';

/**
 * Rapor detayındaki eğitmen ataması. Artık ortak `useTrainingReportSubListData` factory'sinin
 * ince bir sarmalayıcısı (bkz. o dosyadaki not) — yalnızca bu sekmeye özgü 409 (aynı eğitmen
 * ikinci kez atanmaya çalışılıyor, doc §6.2) mesajı `onAddError` ile eklendi, `addInstructor` de
 * factory'nin obje-argüman beklentisine uysun diye tek `userId` argümanını obje'ye sarıyor.
 * Bkz. docs/LMS-Egitim-Raporlari-API.md §6.
 */
const useTrainingReportInstructorsData = (trainingReportId) => {
    const { itemsApi, isLoading, isFetching, isAdding, isDeleting, addItem, removeItem, refetch } = useTrainingReportSubListData({
        trainingReportId,
        useGetQuery: useGetLmsTrainingReportInstructorsQuery,
        useAddMutation: useAddLmsTrainingReportInstructorMutation,
        useDeleteMutation: useDeleteLmsTrainingReportInstructorMutation,
        i18nNamespace: 'instructors',
        onAddError: (err, th) => (err?.status === 409 ? formatErrorMessage(err) || th('trainingReport.instructors.alreadyAssigned') : formatErrorMessage(err) || th('trainingReport.instructors.addError'))
    });

    const addInstructor = (userId) => addItem({ userId });

    return {
        instructorsApi: itemsApi,
        isLoading,
        isFetching,
        isAdding,
        isDeleting,
        addInstructor,
        removeInstructor: removeItem,
        refetch
    };
};

export default useTrainingReportInstructorsData;
